module.exports = __webpack_public_path__ + "fonts/fa-light-300.7c56634.woff2";